<script lang="ts">
export default {
    name: "notice",
}
</script>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import {getNoticeList} from "@/api/system/index"

const sliderData: any = reactive([
    {
        title: "重点通知，明天白天有大到暴雨，无人机不能起飞，请注意安全"
    },
    {
        title: "重点通知，明天白天有大到暴雨，无人机不能起飞，请注意安全"
    },
    {
        title: "重点通知，明天白天有大到暴雨，无人机不能起飞，请注意安全"
    },
    {
        title: "重点通知，明天白天有大到暴雨，无人机不能起飞，请注意安全"
    },
    {
        title: "重点通知，明天白天有大到暴雨，无人机不能起飞，请注意安全"
    },
])
const left = ref(0)
const moveTimer: any = ref(null)

const onStop = () => { // 暂停滚动
    clearInterval(moveTimer.value)
    moveTimer.value = null
}
const onStart = () => { // 开始滚动
    if (sliderData.length > 4) { // 超过4条开始滚动
        getSlide()
    }
}
const getSlide = () => {
    moveTimer.value = setInterval(() => {
        moveLeft()
    }, 5) // 1s移动200次
}

const moveLeft = () => {
    if (left.value >= 950) {
        sliderData.push(sliderData.shift()) // 将第一条数据放到最后
        left.value = 0
    } else {
        left.value += 0.5 // 每次移动0.2px
    }
}

const NoticeList = () =>{
    const params:any = {}
    params.page = 1
    params.size = 999
    getNoticeList(params).then((res)=>{
        Object.assign(sliderData,res.list)
    })
}

onMounted(() => {
    onStart()
    NoticeList()
})

onUnmounted(() => {
    if (moveTimer.value) {
        clearInterval(moveTimer.value);
        moveTimer.value = null
    }
})
</script>

<template>
    <div class="m-slide" @mouseenter="onStop" @mouseleave="onStart" v-if="sliderData.length">
        <div class="title">
            通知：
        </div>
        <div class="content">
            <div :style="`will-change: transform; transform: translateX(${-left}px);`" class="u-slide-title"
                v-for="(item, index) in sliderData" :key="index" :title="item.noticeContent">
                {{ item.noticeContent }}
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.m-slide {
    width: 18vw;
    height: 3.2vh;
    font-size: 1.25rem;
    font-weight: 400;
    line-height: normal;
    color: #FFCC00;
    display: flex;

    .content {
        width: 14.6vw;
        white-space: nowrap;
        overflow: hidden;

        .u-slide-title {
            display: inline-block;
            margin-left: 3.125rem;
            font-size: 1.25rem;
            font-weight: 400;
            line-height: normal;
            color: #FFCC00;
            cursor: pointer;

            &:hover {
                color: #1890FF;
            }
        }
    }
}
</style>